import styled from 'styled-components'

import DropDownIcon from '../../assets/img/drop-down.svg'

export const DropDownHolder = styled.div`
    position: relative;
`

export const DropDownTitle = styled.h4`
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.02em;
    color: #000000;
    padding-right: 15px;
    position: relative;
    cursor: pointer;
    width: auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;

  &.open {
    &:after {
      transform: rotate(180deg);
    }
  }

    &:after {
        content: '';
        width: 8px;
        height: 8px;
        top: 0;
        bottom: 0;
        right: 0;
        position: absolute;
        margin: auto;
        background-repeat: no-repeat;
        background-image: url(${DropDownIcon});
        background-size: contain;
    }
`

export const DropDownItemsWrapper = styled.div`
    min-width: ${props => props?.perPage ? '145px' : '200px'};
    background: #FFFFFF;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    position: absolute;
    padding: ${props => (props.active && !props.courseAward) ? '18px' : '0'};
    top: ${props => props?.perPage ? '-210px' : '20px'};
    z-index: 2;
    right: 0;
    left: ${props => props.perPage ? 'auto' : 0};
    margin: auto;
    height: ${props => props.active ? 'auto' : '0'};
    overflow-y: auto;
    max-height: 200px;
`

export const DropDownItem = styled.h4`
    font-style: normal;
    font-weight: bold;
    cursor: pointer;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.02em;
    padding: 4px;
    color: ${props => props.active ? '#BA8D5B' : props?.mine ? "white" : '#000000'};
    padding-bottom: 10px;
    transition: all ease 0.3s;
    background: ${props => (props.mine && !props?.active) ? 'rgba(63, 195, 128, 0.9)' : (props?.mine && props?.active) ? '#99CCFF' : 'white'};
    margin-bottom: 5px;

    &:hover {
        color: #BA8D5B;
    }

    &:not(:first-child) {
        padding-top: 10px
    }

    &:not(:last-child) {
        padding-bottom: 10px;
    }
`
